import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

export const MotionProvider = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const reading = pathname === '/whitepaper';
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let lenis;
    const configure = () => {
      lenis?.destroy();
      lenis = undefined;
      if (!preference.matches && !reading) lenis = new Lenis({ autoRaf: true, duration: 1.05, smoothWheel: true, syncTouch: false, anchors: false });
    };
    const navigateToAnchor = (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
      let target;
      try { target = document.getElementById(decodeURIComponent(destination.hash.slice(1))); } catch { return; }
      if (!target) return;
      event.preventDefault();
      const headerHeight = document.querySelector('.site-header')?.getBoundingClientRect().height || 88;
      // Use a numeric position: there is a single offset, independent of native
      // scroll-padding and Lenis' element scroll-margin interpretation.
      const destinationY = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 22);
      window.history.pushState(null, '', destination.pathname + destination.hash);
      const focus = () => {
        const focusTarget = target.matches('h1,h2,h3,h4,h5,h6,main') ? target : target.querySelector('h2,h1');
        if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus({ preventScroll: true }); }
      };
      if (lenis) lenis.scrollTo(destinationY, { duration: 0.85, force: true, onComplete: focus });
      else { window.scrollTo({ top: destinationY, behavior: 'instant' }); focus(); }
    };
    configure();
    preference.addEventListener('change', configure);
    document.addEventListener('click', navigateToAnchor);
    return () => { lenis?.destroy(); preference.removeEventListener('change', configure); document.removeEventListener('click', navigateToAnchor); };
  }, [pathname]);
  return children;
};